{
  "name": "@reslava/loom",
  "version": "1.16.0",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/reslava/loom.git",
    "directory": "packages/cli"
  },
  "type": "commonjs",
  "files": [
    "dist",
    "LICENSE"
  ],
  "main": "dist/index.js",
  "bin": {
    "loom": "dist/index.js"
  },
  "scripts": {
    "build": "node esbuild.js",
    "prepublishOnly": "node esbuild.js --production",
    "typecheck": "tsc --noEmit"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.0.0"
  },
  "devDependencies": {
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^22.0.0",
    "chalk": "^5.3.0",
    "commander": "^12.0.0",
    "esbuild": "^0.28.0",
    "fs-extra": "^11.3.0",
    "typescript": "^5.5.0"
  }
}
